// extracted by mini-css-extract-plugin
module.exports = {"label":"CourseAttribute_label__CNg2d","text":"CourseAttribute_text__nEz_L","link":"CourseAttribute_link__WH_YU"};